import { render, staticRenderFns } from "./PremiumCommissionLadder.vue?vue&type=template&id=f64d5030&scoped=true"
import script from "./PremiumCommissionLadder.vue?vue&type=script&lang=ts"
export * from "./PremiumCommissionLadder.vue?vue&type=script&lang=ts"
import style0 from "./PremiumCommissionLadder.vue?vue&type=style&index=0&id=f64d5030&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f64d5030",
  null
  
)

export default component.exports